/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementDeleteEventImageResponse } from './EventSceneManagementDeleteEventImageResponse';

export type EventSceneManagementDeleteEventImageResponseApiRespoonse = {
    data?: EventSceneManagementDeleteEventImageResponse;
    status?: EventSceneManagementDeleteEventImageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementDeleteEventImageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

